import React from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";

import CasinoTab from "./casino.jsx";
import LiveTab from "./live.jsx";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const Tab = ({ type }) => {
	const { translate } = useSelector(selectTranslate);

	switch (type) {
		case "casino":
			return <CasinoTab translate={translate} />;
		case "livecasino":
			return <LiveTab translate={translate} />;
		default:
			return null;
	}
};

export default Tab;
